import { useContext } from "react";
import { LayoutContext } from "./LayoutProvider";

function useLayout() {
    const context = useContext(LayoutContext);
    if (!context) {
        throw Error("No LayoutContext!");
    }

    return context;
}

export default useLayout;
